import Logger from '../lib/logger';

const NAME = 'AccessibleGroup';

const GROUP = '[data-screen-reader-text]';
const FOCUSABLE =
	'a[href], button, input:not([type=hidden]), select, textarea, summary, iframe, [tabindex]:not([tabindex^="-"])';

/**
 * initAccessibleGroups - Ignore a group's screen reader text when it would hide a control.
 *
 * The substitution hides the group's contents. A focusable element inside that subtree stays
 * keyboard-reachable while being invisible to a screen reader, and no descendant can opt back in --
 * aria-hidden="false" does not escape a hidden ancestor. Liquid can't see the group's children, since
 * they render through {% content_for 'blocks' %}, so the check has to happen here.
 */
export const initAccessibleGroups = () => {
	Logger.info(`${NAME} > initAccessibleGroups`);

	for (const group of document.querySelectorAll(GROUP)) {
		if (!group.querySelector(FOCUSABLE)) continue;

		for (const hidden of group.querySelectorAll(':scope > [aria-hidden="true"]')) {
			hidden.removeAttribute('aria-hidden');
		}
		group.querySelector('[data-screen-reader-text-content]')?.remove();
		group.removeAttribute('data-screen-reader-text');
	}
};

export default initAccessibleGroups;
